import {createTransform} from "redux-persist";
import cryptoJs from "crypto-js";
import padZeroPadding from "crypto-js/pad-zeropadding";
import Utf8 from "crypto-js/enc-utf8";

const key = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);
const iv = cryptoJs.enc.Hex.parse(import.meta.env.VITE_SALT_ENCRYPT);

export const encryptPersistData = createTransform(
  inboundState => {
    if (inboundState != undefined) {
      const data = JSON.stringify(inboundState);
      const dataEncrypted = cryptoJs.AES.encrypt(data, key, {
        iv: iv,
        padding: padZeroPadding,
      }).toString();
      return dataEncrypted;
    }
  },
  outboundState => {
    const data = cryptoJs.AES.decrypt(outboundState, key, {
      iv: iv,
      padding: padZeroPadding,
    }).toString(Utf8);
    const dataDecrypted = JSON.parse(`${data.trim()}`);

    return dataDecrypted;
  },
);
